import { disableBodyScroll, enableBodyScroll } from '@/utils/DOM'
import { makeAutoObservable } from 'mobx'

export class MessageStore {
  visible: boolean = false
  title: string = ''
  description: string = ''

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  show(title: string, description: string = '') {
    disableBodyScroll()
    this.visible = true
    this.title = title
    this.description = description
  }

  hide() {
    enableBodyScroll()
    this.visible = false
    this.title = ''
    this.description = ''
  }
}

export const messageStore = new MessageStore()
